<template>
    <div class="timeline-filters">
        <CompassButton :label="timelineFilterslabelBtn" type="secondary" @click="toggleList" />
        <transition name="fade">
            <div v-show="displayList" class="timeline-content-filters">
                <h3 class="dinlineb mt-0 mb-3">
                    {{ $l10n.__('Filtrer par thématique') }}
                </h3>
                <div class="inlineb fright">
                    <a href="javascript:;" @click="toggleList">
                        <i class="fa icon-close fs-4" />
                    </a>
                </div>

                <div class="form-group fs-3">
                    <ul class="filters m-0">
                        <li class="mb-4">
                            <el-checkbox
                                :indeterminate="isIndeterminateAll"
                                :value="allChecked"
                                @change="toggleAllEntities"
                                >{{ $l10n.__('Tout sélectionner') }}
                            </el-checkbox>
                            <span class="valign-bottom gray-60 ml-3">{{
                                $l10n.n__(
                                    '%s filtre sélectionné',
                                    '%s filtres sélectionnés',
                                    nbEntitiesChecked,
                                    nbEntitiesChecked,
                                )
                            }}</span>
                        </li>
                    </ul>
                    <ul class="filters m-0">
                        <li
                            v-for="(group, groupIndex) in valueListable"
                            v-if="group.entities.length > 0"
                            :key="groupIndex"
                            class="dinlineb span_4 valign-top mb-4"
                        >
                            <el-checkbox
                                :indeterminate="isIndeterminate(group)"
                                :value="isChecked(group)"
                                @change="toggleGroup(group)"
                                >{{ group.label }}</el-checkbox
                            >
                            <ul>
                                <li
                                    v-for="(entity, entityIndex) in group.entities"
                                    :key="entityIndex"
                                    class="ml-3 mt-1"
                                >
                                    <el-checkbox v-model="entity.checked">{{
                                        entity.label
                                    }}</el-checkbox>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <div
                    v-for="(group, groupIndex) in valueComponent"
                    :key="groupIndex"
                    class="form-group fs-3 bt-1 pt-2"
                >
                    <h4>{{ group.label | capitalize }}</h4>
                    <component
                        :is="`${group.component}`"
                        :selected="group.selected"
                        @input="inputFilter"
                    />
                </div>

                <!-- Disable filter date for beta -->
                <h3 class="mt-3 fs-3 semibold">
                    {{ $l10n.__('Filtrer par date') }}
                </h3>
                <div class="form-group">
                    <date-input
                        v-model="date"
                        mode="edit"
                        :placeholder="placeholderDatePicker"
                        :format="timeformat"
                        :options="datePickerOptions"
                    />
                </div>

                <div class="aright mt-2">
                    <CompassButton
                        :label="$t.__('common.actions.apply')"
                        type="primary"
                        :disabled="nbEntitiesChecked == 0 ? true : false"
                        @click="initFilter"
                    />
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import TimelineAuthorFilter from './TimelineAuthorFilter.vue';

import { createNamespacedHelpers } from 'vuex';
import DateInput from 'vcomponents/inputs/DateInput.vue';

const { mapState } = createNamespacedHelpers('corp');

export default {
    components: {
        DateInput,
        TimelineAuthorFilter,
    },
    props: {
        value: {
            type: Array,
            required: true,
        },
        presetDate: {
            type: [Number, String, Date],
            required: false,
        },
    },
    data() {
        return {
            displayList: false,
            date: '',
            loader: false,
            filters: {},
        };
    },
    computed: {
        ...mapState(['timeformat']),

        valueListable() {
            return this.value.filter((one) => one.type == undefined || one.type == 'list');
        },
        valueComponent() {
            return this.value.filter((one) => one.type == 'component');
        },
        nbEntities() {
            let nbEntities = 0;
            this.value.map((group) => {
                nbEntities += group.entities.length;
            });
            return nbEntities;
        },
        nbEntitiesChecked() {
            let entitiesChecked = 0;
            this.value.map((group) => {
                group.entities.map((entity) => {
                    entity.checked ? entitiesChecked++ : false;
                });
            });

            return entitiesChecked;
        },
        labelEntitiesChecked() {
            const entitiesChecked = [];
            this.value.map((group) => {
                group.entities.map((entity) => {
                    if (entity.checked) {
                        entitiesChecked.push(entity.value);
                    }
                });
            });

            return entitiesChecked;
        },
        nbFiltersLabel() {
            return this.nbEntitiesChecked + '/' + this.nbEntities;
        },
        isIndeterminateAll() {
            if (this.nbEntitiesChecked > 0 && this.nbEntitiesChecked < this.nbEntities) {
                return true;
            }
            return false;
        },
        allChecked() {
            if (this.nbEntitiesChecked === 0) {
                return false;
            } else {
                return this.nbEntitiesChecked === this.nbEntities;
            }
        },
        placeholderDatePicker() {
            return this.timeformat === 'mdy'
                ? this.$l10n.__('MM/JJ/AAAA')
                : this.$l10n.__('JJ/MM/AAAA');
        },
        datePickerOptions() {
            return {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            };
        },
        timelineFilterslabelBtn() {
            return this.$l10n.__("Filtrer l'activité") + ' ' + this.nbFiltersLabel;
        },
    },
    created() {
        if (this.presetDate) {
            this.date = moment(this.presetDate, 'X').format('YYYY-MM-DD HH:mm:ss');
        }
    },
    methods: {
        toggleList() {
            this.displayList = !this.displayList;
        },
        initFilter() {
            this.toggleList();
            this.applyFilter();
        },
        applyFilter() {
            const end = moment(this.date, 'YYYY/MM/DD HH:mm:ss')
                .add('day', 1)
                .add('seconds', -1)
                .format('X');

            this.$emit('applyFilter', {
                entities: this.labelEntitiesChecked,
                filters: this.filters,
                end: end === 'Invalid date' ? '' : end,
                start: '',
            });
        },
        toggleAllEntities() {
            let entitiesChecked = 0;
            this.value.map((group) => {
                group.entities.map((entity) => {
                    entity.checked ? entitiesChecked++ : false;
                });
            });

            if (entitiesChecked == 0 || entitiesChecked < this.nbEntities) {
                this.value.map((group) => {
                    group.entities.map((entity) => {
                        entity.checked = true;
                    });
                });
            } else {
                this.value.map((group) => {
                    group.entities.map((entity) => {
                        entity.checked = false;
                    });
                });
            }
        },
        isIndeterminate(group) {
            const allGroupEntities = this.value.find(
                (oneGroup) => oneGroup.value == group.value,
            ).entities;
            const entitiesChecked = allGroupEntities.filter((entity) => entity.checked);
            if (entitiesChecked.length > 0 && entitiesChecked.length < allGroupEntities.length) {
                return true;
            }
            return false;
        },
        isChecked(group) {
            const allGroupEntities = this.value.find(
                (oneGroup) => oneGroup.value == group.value,
            ).entities;
            const entitiesChecked = allGroupEntities.filter((entity) => entity.checked);
            if (entitiesChecked.length == 0) {
                return false;
            } else if (entitiesChecked.length == allGroupEntities.length) {
                return true;
            }
        },
        toggleGroup(group) {
            const entitiesChecked = group.entities.filter((entity) => entity.checked);
            if (entitiesChecked.length == 0 || entitiesChecked.length < group.entities.length) {
                group.entities.map((entity) => (entity.checked = true));
            } else {
                group.entities.map((entity) => (entity.checked = false));
            }
        },
        inputFilter(filter, choices) {
            choices.length ? (this.filters[filter] = choices) : delete this.filters[filter];
        },
    },
};
</script>

<style lang="scss" scoped>
.timeline-filters {
    .timeline-content-filters {
        position: absolute;
        left: 0;
        right: 0;
        width: 776px;
        padding: var(--spacing-3);
        background-color: var(--colors-common-background-default);
        box-shadow: 0 2px var(--spacing-2) #0000001a;
        border-radius: var(--spacing-0);
        border: solid 1px var(--colors-common-border-default);
        z-index: 2;
    }
}
.el-date-editor--daterange {
    width: 300px;
}

.el-date-editor {
    height: auto !important;
}
</style>
